import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useTemplateViews } from "src/components/providers/template-views-provider";

const RedirectToOverview = () => {
    const { teamId } = useParams();
    const { templateViews } = useTemplateViews();
    const teamViews = templateViews?.teamViews.find((v) => v.teamId === teamId);
    const defaultTeamView = (teamViews?.views || []).find((v) => v.isDefault);
    const defaultRouteDashboard = defaultTeamView?.dashboards?.find((d) => d.isDefaultRoute);
    if (defaultRouteDashboard && defaultRouteDashboard.urlHandle) {
        return (
            <Navigate
                to={`/teams/${teamId}/dashboard/${defaultRouteDashboard.urlHandle}`}
                replace
            />
        );
    }
    return <Navigate to={`/teams/${teamId}/dashboard/insights`} replace />;
};

export default RedirectToOverview;
